import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import OTPVerification from "./pages/OTPVerification";
import ResetPassword from "./pages/ResetPassword";
import Signin from "./pages/Signin";
// import Signup from "./pages/Signup";
import Privacy from "./pages/Privacy/Privacy";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SkeletonTheme } from "react-loading-skeleton";
import AdminArea from "./customHook/AdminArea";
import DashboardCom from "./components/DashboardComponents/DashboardCom";
import SuperAdminDashboard from "./components/DashboardComponents/SuperAdminDashboard";
import AllProjects from "./pages/SuperAdmin/AllProjects";
import AllOrganizations from "./pages/SuperAdmin/AllOrganizations";
import AddOrganization from "./pages/SuperAdmin/AddOrganization";
import AllManagers from "./pages/SuperAdmin/AllManagers";
import SubscriptionManagement from "./pages/SuperAdmin/SubscriptionManagement";
import ProjectDetails from "./pages/SuperAdmin/ProjectDetails";

import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import ViewProjects from "./pages/Events/ViewProjects";
import ViewProjectDetails from "./pages/Events/ViewProjectDetails";
import ViewSinglePhoto from "./pages/Events/ViewSinglePhoto";
import ViewWorker from "./pages/Workers/ViewWorker";
import AddWorker from "./pages/Workers/AddWorker";
import WorkerProjectAllocation from "./pages/Events/WorkerProjectAllocation";
import Expenses from "./pages/Expenses";
import WorkerProgress from "./pages/Workers/WorkerProgress";
import UserProfile from "./components/DashboardComponents/UserProfile";
import SendProgress from "./pages/Events/SendProgress";
import ExpenseDetails from "./pages/Expenses/ExpenseDetails";
import WorkerDetails from "./pages/Workers/WorkerDetails";
import CreateProject from "./pages/Events";
import ProgressDetailPage from "./pages/Events/ProgressDetailPage";
import ChatInterFace from "./pages/Events/ChatInterFace";
import SearchMap from "./components/common/SearchMap";
import ViewTasks from "./pages/Tasks/ViewTasks";
import ViewVendor from "./pages/Vendor/ViewVendor";
import AddVendor from "./pages/Vendor/AddVendor";
import Organization from "./pages/Organization/Organization";
import ImageView from "./pages/ImageView/ImageView";
import { setPlan, initializeToken } from "./redux/feature/AuthSlice";

function App() {
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.auth.token);
  // const isLoggedIn = !!authToken;
  const token = localStorage.getItem("token");
  const [isLoggedIn, setIsLoggedIn] = useState(!!token);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);


  useEffect(() => {
    // Initialize token from localStorage
    dispatch(initializeToken());

    // Get user data from localStorage
    const userDataString = localStorage.getItem('userData');
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        setIsSuperAdmin(userData?.user?.user?.role?.toLowerCase() === 'super_admin');

        // If plan exists in user data, use it; otherwise, use 'basic'
        const userPlan = userData?.plan || 'basic';
        // const userPlan =  'ultimate';
        console.log('Setting user plan:', userPlan);
        dispatch(setPlan(userPlan));
      } catch (error) {
        console.error('Error parsing user data:', error);
        dispatch(setPlan('basic'));
      }
    } else {
      dispatch(setPlan('basic'));
    }
  }, [dispatch]);

  const adminRoutes = [
    { path: "/", Comp: DashboardCom },
    { path: "/view-project", Comp: ViewProjects },
    { path: "/project-details", Comp: ViewProjectDetails },
    { path: "/project-details/:id", Comp: ViewProjectDetails },
    { path: "/single-photo", Comp: ViewSinglePhoto },
    { path: "/view-worker", Comp: ViewWorker },
    { path: "/add-project", Comp: CreateProject },
    { path: "/add-worker", Comp: AddWorker },
    { path: "/project-allocation", Comp: WorkerProjectAllocation },
    { path: "/expenses", Comp: Expenses },
    { path: "/worker-progress", Comp: WorkerProgress },
    // { path: "/profile", Comp: UserProfile },
    { path: "/project-progress", Comp: SendProgress },
    { path: "/expense-details", Comp: ExpenseDetails },
    { path: "/worker-details/:id", Comp: WorkerDetails },
    { path: "/progress-detail", Comp: ProgressDetailPage },
    // { path: "/chat", Comp: ChatInterFace },
    // { path: "/map", Comp: SearchMap },
    { path: "/organization", Comp: Organization },
    { path: "/view-tasks", Comp: ViewTasks },
    { path: "/view-vendor", Comp: ViewVendor },
    { path: "/add-vendor", Comp: AddVendor },
    { path: "/image-view", Comp: ImageView },
  ];

  const superAdminRoutes = [
    { path: "/", Comp: SuperAdminDashboard },
    { path: "/super-admin/projects", Comp: AllProjects },
    { path: "/super-admin/all-projects", Comp: AllProjects },
    { path: "/super-admin/project-details/:id", Comp: ProjectDetails },
    { path: "/super-admin/managers", Comp: AllManagers },
    { path: "/super-admin/add-organization", Comp: AddOrganization },
    { path: "/super-admin/subscription-management", Comp: SubscriptionManagement },
  ];


  const routes = isSuperAdmin ? superAdminRoutes : adminRoutes;

  return (
    <>
      <ToastContainer closeOnClick={false} closeButton={true} />
      <SkeletonTheme baseColor="#D8D8D8" highlightColor="#c9c9c9">
        <BrowserRouter>
          <Routes>
            {isLoggedIn ? (
              <>
                {routes.map(({ path, Comp }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <AdminArea>
                        <Comp />
                      </AdminArea>
                    }
                  />
                ))}
                {/* Redirect super admin to dashboard for any invalid route */}
                {isSuperAdmin && (
                  <Route path="*" element={<Navigate to="/" replace />} />
                )}
              </>
            ) : (
              <Route path="*" element={<Navigate to="/signin" />} />
            )}

            <Route
              path="/signin"
              element={isLoggedIn ? <Navigate to="/" /> : <Signin />}
            />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/verify-otp" element={<OTPVerification />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* <Route path="/signup" element={<Signup />} /> */}
          </Routes>
        </BrowserRouter>
      </SkeletonTheme>
    </>
  );
}

export default App;
